var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute full panel-closer bg-black-transp cursor-pointer",on:{"click":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }